import http from "./http-common";

export interface GlobalSearchResults {
  actives: { id: number; name: string; type: string }[];
  patients: { id: number; name: string }[];
  consultations: { id: number; name: string; date: string; type: string }[];
}

export const globalSearch = (q: string) =>
  http.get<GlobalSearchResults>(`/search?q=${encodeURIComponent(q)}&limit=8`);
